import { useSearchParams } from 'react-router-dom';

/** Subpestaña en ?sub=. Si el valor no es válido, se muestra la de por defecto. */
export function useUrlSubTab<T extends string>(
    allowed: readonly T[],
    fallback: T,
): readonly [T, (next: T) => void] {
    const [params, setParams] = useSearchParams();
    const raw = params.get('sub');
    const current = (allowed as readonly string[]).includes(raw ?? '') ? (raw as T) : fallback;

    const setCurrent = (next: T) => {
        const rawIsAllowed = (allowed as readonly string[]).includes(raw ?? '');
        if (raw === next || (!rawIsAllowed && next === fallback)) return;
        setParams((prev) => {
            const updated = new URLSearchParams(prev);
            updated.set('sub', next);
            return updated;
        });
    };

    return [current, setCurrent] as const;
}
